export const onboardingErrorText = (error: unknown, depth = 0): string => {
	if (typeof error === 'string') return error === '[object Object]' ? '' : error;
	if (!error || typeof error !== 'object' || Array.isArray(error) || depth >= 4) return '';
	const value = error as Record<string, unknown>;
	for (const key of ['detail', 'message', 'content', 'error']) {
		const text = onboardingErrorText(value[key], depth + 1);
		if (text.trim()) return text;
	}
	return '';
};
